import { gql } from '@apollo/client';

export const EMPTY_MUTATION = gql`
  mutation {
    _empty
  }
`;
